import React from 'react'
import Header from '../headerone/Main'
import Bredcom from '../Bredcom/Main'
import NewMain from '../headerone/newMain'
function AboutDeanRdc() { 
  return (
    <>
      <NewMain />
      <Bredcom title="Home" subtitle="About Director, RDC" />
      <section className="about-area about-p pt-60 pb-60 p-relative fix">
        <div className="animations-02">
          <img src="/assets/img/bg/an-img-02.png" alt="contact-bg-an-01" />
        </div>
        <div className="container">
          <div className="row justify-content-center ">
            <div className="col-lg-4 col-md-12 col-sm-12">
              <div className="wow fadeInLeft animated" data-animation="fadeInLeft" data-delay=".4s" > 
                <img src={`${process.env.PUBLIC_URL}/assets/img/new_images/direction_rdc_new.jpg`}  alt="img" className="vc-img" />
                <div className="vc-about"> 
                  <p><strong>Dr Manoj Kumar Ojha </strong> <br/>Director, RDC </p> 
                </div>
              </div>
            </div>
            <div className="col-lg-8 col-md-12 col-sm-12">
              <div className="about-content s-about-content pl-15 wow fadeInRight  animated" data-animation="fadeInRight" data-delay=".4s" >
                <div className="about-title second-title pb-25">
                  {/* <h5>
                    <i className="fal fa-graduation-cap" /> Chancellor’s Message
                  </h5> 
                  <h2>Pro Vice Chancellor Message</h2> */}
                </div>
                <p >

                  Dr. Manoj Kumar Ojha is an accomplished academician and researcher, currently serving as Professor and Dean Academics at MVN University, Palwal. With over 21 years of professional experience, he has made significant contributions to the fields of Artificial Intelligence, Computer Vision, and Bio-Medical Engineering. Dr. Ojha holds a Ph.D. in Electronics, specializing in Artificial Intelligence and Machine Learning from MITS, Gwalior. He has completed Master of Engineering in 2005 and a Bachelor of Engineering in 2003 from RGPV, Bhopal (both with distinction). He is presently pursuing Post-Doctoral Research (Remote) from Singapore Institute of Technology, Singapore. Dr. Ojha has authored over 50 research papers published in SCIE and Scopus-indexed journals, and also holds several patents. His research interest includes intelligent healthcare systems, IoT deployments, computer vision, and machine learning and deep learning applications. He received the Best Paper Award at the International Conference on Computational Intelligence (2021).  <br/> <br/>
                  
Dr. Ojha has played key roles in university functions in previous assignments including Controller of Examination, curriculum development aligned with NEP 2020, research administration, and ERP systems integration. His teaching portfolio includes Pattern Recognition, Machine Learning and Data Science with Python, and Digital Image Processing. He has also contributed to national education initiatives through SWAYAM lecture recordings on “Digital Electronics and System Design.”  <br/> <br/>
Dr. Ojha’s leadership is marked by his commitment to integrating technology in education, implementing quality assurance measures, and promoting multidisciplinary approaches in alignment with Industry 5.0 requirements.
At MVN University, Dr. Ojha continues to lead groundbreaking research initiatives while mentoring Ph.D. scholars and teaching undergraduate and postgraduate students.  <br/> <br/>

For inquiries or collaboration opportunities, Dr. Ojha can be reached via email at deanacademics@mvn.edu.in or by phone at +91-9425777975.


 
                
                </p>
                                
              </div>
            </div>
          </div>
        </div>
      </section>

    </>
  )
}

export default AboutDeanRdc